import { render, staticRenderFns } from "./CustomData.vue?vue&type=template&id=b1533906&scoped=true"
import script from "./CustomData.vue?vue&type=script&lang=js"
export * from "./CustomData.vue?vue&type=script&lang=js"
import style0 from "./CustomData.vue?vue&type=style&index=0&id=b1533906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1533906",
  null
  
)

export default component.exports